import React from 'react';
import { Countdown } from './Shared';
export const UrgencySection = () => {
  return <section id="precio-lanzamiento" className="bg-familia-bg border-t border-familia-cyan/30 py-7 md:py-11 px-4 md:px-6" data-id="element-254">
      <div className="max-w-3xl mx-auto text-center w-[92%] md:w-full" data-id="element-255">
        <h2 className="text-familia-red font-bold text-sm sm:text-lg md:text-xl mb-5 md:mb-8 animate-blink uppercase tracking-widest text-center" data-id="element-256">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <Countdown className="mb-5 md:mb-8 scale-90" data-id="element-257" />

        <p className="text-familia-gray text-xs sm:text-sm md:text-base mb-5 md:mb-8 text-center" data-id="element-258">
          Después sube y no vuelve a bajar.
        </p>

        <div className="max-w-sm mx-auto bg-familia-card border border-familia-cyan/25 p-3 md:p-4 rounded-xl" data-id="element-259">
          <div className="flex justify-between items-center mb-3" data-id="element-260">
            <div className="flex items-center gap-2" data-id="element-261">
              <span className="w-1.5 h-1.5 bg-familia-red rounded-full animate-ping" data-id="element-262" />
              <span className="text-[10px] sm:text-xs font-bold" data-id="element-263">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-familia-red font-bold text-[10px] sm:text-xs" data-id="element-264">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-white/5 h-2 rounded-full overflow-hidden" data-id="element-265">
            <div className="bg-familia-cyan h-full w-[15%]" data-id="element-266" />
          </div>
        </div>
      </div>
    </section>;
};